// Dati di MK Consulting mostrati nell'app (piede della pagina di accesso).
// Sono gli stessi del sito mkconsulting.it: se cambiano, vanno aggiornati in entrambi.
const AZIENDA = {
  nome: 'MK Consulting',
  via: 'Via Matteotti 16',
  cap: '20811',
  citta: 'Cesano Maderno',
  provincia: 'MB',
  partitaIva: '12501960962',
  telefono: '+39 320 787 5482',
  telefonoHref: 'tel:+393207875482',
  sito: 'https://mkconsulting.it',
};

export default AZIENDA;
